"use client";

import { c as _c } from "react/compiler-runtime";
import SubscriptionsReportComponent from "@/components/subscriptions-report/SubscriptionsReport";
import { useSetTitle } from "@/contexts/TitleContext";
import styles from "@/styles/Home.module.scss";
export default function SubscriptionsReport() {
  const $ = _c(1);
  useSetTitle("Subscriptions Report | Tools");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <main className={`${styles.main} tailwind-scope !tw-bg-iron-950`}><SubscriptionsReportComponent /></main>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}